import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { SubmenusActions } from './submenus.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { ConsumersActions } from '../consumer/consumers.actions';
import { LocationSetsActions } from '../location-sets/location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import { AsyncActions } from './submenus.actions';
import {Submenu} from '@emm/core/models/submenu.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const submenusFeatureKey = 'submenus';

export interface SubmenusState extends EntityState<Submenu>, AsyncActionState {
    selectedTag: string | null;
    selectedSearchTag: string | null;
}

export const adapter: EntityAdapter<Submenu> = createEntityAdapter<Submenu>({
    selectId: (submenu: Submenu) => submenu.id,
    sortComparer: null
});

export const initialState: SubmenusState = adapter.getInitialState({
    selectedTag: null,
    selectedSearchTag: null,
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const submenusReducer = withLoadables<SubmenusState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, state => ({
        ...initialState,
    })),

    on(
        ConsumersActions.select,
        ConsumersActions.deleteSuccess,
        ConsumersActions.reloadConsumers,
        LocationSetTypesActions.select,
        LocationSetsActions.select,
        SubmenusActions.load,
        (state: SubmenusState) => {
            return adapter.removeAll({
                ...state,
                selectedTag: null,
            });
        }
    ),

    on(SubmenusActions.loadSuccess, (state: SubmenusState, { submenus }) => {
        return adapter.setAll(submenus, state);
    }),

    on(SubmenusActions.select, (state: SubmenusState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

    on(SubmenusActions.deselect, (state: SubmenusState, { tag }) => ({
        ...state,
        selectedTag: null
    })),

    on(SubmenusActions.selectSearchSubmenu, (state: SubmenusState, { tag }) => ({
        ...state,
        selectedSearchTag: tag
    })),

    on(SubmenusActions.deselectSearchSubmenu, (state: SubmenusState) => ({
        ...state,
        selectedSearchTag: null
    })),

    on(SubmenusActions.filterSubmenus, (state: SubmenusState, { submenus }) => ({
        ...state,
        submenus
    })),

);
